import React from 'react';

import { AxiosRequestConfig } from 'axios';
import Autocomplete from 'src/components/Form/Autocomplete';
import { AutocompleteProps } from 'src/components/Form/Autocomplete/interfaces';
import api from 'src/services/api';

type AutocompleteLeadsProps = {
  requestConfig?: AxiosRequestConfig;
} & Omit<AutocompleteProps, 'options'>;

const AutocompleteLeads: React.FC<AutocompleteLeadsProps> = ({
  requestConfig,
  ...rest
}) => {
  const { isLoading, data: response } = api.admin.common.useLeadsQuery({
    requestConfig,
  });

  const options =
    response?.data?.map((lead) => ({
      key: lead.id,
      label: lead.name,
      value: lead.id,
      data: lead,
    })) || [];

  return <Autocomplete {...rest} loading={isLoading} options={options} />;
};

export default AutocompleteLeads;
